import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconContacts: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconContacts"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H20V20.5H5.5V19.5H20V2H4ZM15 14.5H9C9 12.6372 9.96455 11.75 12 11.75C14.0354 11.75 15 12.6372 15 14.5ZM12 7.5C11.0335 7.5 10.25 8.2835 10.25 9.25C10.25 10.2165 11.0335 11 12 11C12.9665 11 13.75 10.2165 13.75 9.25C13.75 8.2835 12.9665 7.5 12 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconContacts;
